module.exports = __webpack_public_path__ + "img/es-testimonial-1.741a5b3d.png";